<app-details-panel-shell
  *ngIf="day"
  [visible]="visible"
  [showEditButton]="false"
  [title]="title"
  (onClose)="close.emit()">
  <div class="data-tab day-agenda-list">
    <div class="entry-row"
      *ngFor="let entry of day.entries; trackBy: trackByEntryId"
      [class.entry-row-active]="entry.id === selectedEntryId"
      (click)="entryClick.emit(entry)">
      <div class="entry-info">
        <div class="entry-title">{{ entry.title }}</div>
        <div class="entry-type" [ngClass]="entry.chipClass">
          <span class="entry-dot"></span>{{ entry.chipLabel }}
        </div>
      </div>
    </div>
  </div>
</app-details-panel-shell>
